import { Icon } from '@sb1/ffe-icons-react';
import { useProject } from '../../project-hooks/useProject';
import { BodyText, Heading2 } from '@sb1/ffe-core-react';
import { ModalBlock } from '@sb1/ffe-modals-react';
import styles from './shareOnProject.module.less';
import copyIcon from '@sb1/ffe-icons/icons/open/300/md/content_copy.svg';
import { PrimaryButton, SecondaryButton } from '@sb1/ffe-buttons-react';
import { useSelector } from 'react-redux';
import { InputGroup, TextArea } from '@sb1/ffe-form-react';
import copy from 'clipboard-copy';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';

export const EmbedModalContainer = ({ onBack, trackingProperties }) => {
    const project = useProject();
    const { baseUrl } = useSelector((state) => ({
        baseUrl: state.baseURL,
    }));
    const embedUrl = `${baseUrl}/project/${project.id}/embed`;
    const iframeCode = `<iframe width='350' height='510' src='${embedUrl}' frameborder='0'></iframe>`;
    return (
        <ModalBlock>
            <Heading2 id="share-modal-title">Bygg inn spleisen</Heading2>
            <BodyText>
                Bygg spleisen inn i din nettside, slik at besøkende kan klikke seg direkte inn på spleisen.
            </BodyText>
            <div>
                <div className={styles.iframeContainer}>
                    <iframe src={embedUrl}></iframe>
                </div>
                <InputGroup label={'Lim inn HTML-koden i din nettside'} extraMargin={false}>
                    <TextArea
                        onFocus={(node) => node.target.select()}
                        defaultValue={iframeCode}
                        autoFocus="autoFocus"
                        className={styles.embeddedMarkup}
                    />
                </InputGroup>
                <div className={styles.downloadButtons}>
                    <SecondaryButton onClick={onBack}>Tilbake</SecondaryButton>
                    <PrimaryButton
                        leftIcon={<Icon fileUrl={copyIcon} />}
                        onClick={() => {
                            trackEvent('project', `embed-modal-copy`, { channel: type, ...trackingProperties });
                            copy(iframeCode);
                        }}
                    >
                        Kopiér koden
                    </PrimaryButton>
                </div>
            </div>
        </ModalBlock>
    );
};
